$("#m-rating").on("show.bs.modal", function () {
	setTimeout(function () {
		moveProgressBar();
	}, 500);
});

window.onresize = moveProgressBar;

const bars = document.querySelectorAll(".bar");
const progress = document.querySelectorAll(".progress");

function moveProgressBar() {
	$(".progress-wrap").each(function () {
		let item = $(this);
		let getPercent = (item.data("progress-percent") / 100);
		let getProgressWrapWidth = item.width();
		let progressTotal = getPercent * getProgressWrapWidth;
		let animationLength = 2500;

		item.find(".progress-bar").stop().animate({
			left: progressTotal
		}, animationLength);
	});
}
moveProgressBar();